import { useCallback, useState } from 'react';
import { Carousel } from 'react-bootstrap';

import { useAnalytics } from '@features/Analytics';

import Button from '../../../common/button/button';
import styles from './discover-slider-step.module.scss';

const TEXTS = [
  {
    title: 'Decode Moon’s influence on your destiny with two easy steps',
    subtitle: '',
    eventName: '',
    eventNameChosen: 'onboarding_decode_moons_influence_chosen',
  },
  {
    title: (
      <>
        Step one: <br /> identify <b>where you are</b>
      </>
    ),
    subtitle:
      'A few more questions to understand your behavior patterns. Be as honest as possible: this will affect your profile directly',
    eventName: 'onboarding_step_one_where_you_opened',
    eventNameChosen: 'onboarding_step_one_where_you_chosen',
  },
  {
    title: (
      <>
        Step two: <br /> identify <b>what you want</b>
      </>
    ),
    subtitle:
      'Break the karmic cycle, improve your relationships, or find true love? Eclipse will help, but you need to have a clear intention',
    eventName: 'onboarding_step_two_what_you_want_opened',
    eventNameChosen: 'onboarding_step_two_what_you_want_chosen',
  },
];

export const DiscoverSliderStep = ({ onChange }: { onChange: () => void }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const { trackGoogleEvent } = useAnalytics();

  const handleClick = useCallback(
    (currentSlideIndex: number) => {
      const currentEventNameChosen = TEXTS[currentSlideIndex].eventNameChosen;
      const nextEventName =
        currentSlideIndex < TEXTS.length - 1
          ? TEXTS[currentSlideIndex + 1].eventName
          : null;

      trackGoogleEvent({
        eventName: currentEventNameChosen,
      });

      if (nextEventName) {
        trackGoogleEvent({
          eventName: nextEventName,
        });
      }

      currentSlideIndex === TEXTS.length - 1
        ? onChange()
        : setCurrentSlideIndex(currentSlideIndex + 1);
    },
    [onChange, trackGoogleEvent],
  );

  return (
    <div className={styles.container}>
      <Carousel
        activeIndex={currentSlideIndex}
        className={styles.carousel}
        controls={false}
        interval={null}
        touch={false}>
        {TEXTS.map((slide, index) => (
          <Carousel.Item as="article" key={index}>
            <h1 className={styles.title}>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </Carousel.Item>
        ))}
      </Carousel>
      <Button
        onClick={() => {
          handleClick(currentSlideIndex);
        }}
        className={styles.nextButton}>
        Next
      </Button>
    </div>
  );
};
